export const SESSION_STORAGE_KEYS = {
  TENANT_ID: 'TenantId',
  ONBOARDING_ACTIVE: 'OnboardingActive',
  ONBOARDING_NEW_ORGANIZATION_NAME: 'OnboardingOrganizationName',
  ONBOARDING_LICENSE_KEY: 'OnboardingLicenseKey',
  CLIENT_LANGUAGE: 'ClientLanguage',
} as const;
